import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'

function mapStateToProps(state, hocProps) {
    const activePortfolioType = state.getIn(['ui', 'modules', hocProps.module, 'ribbon', 'portfolios', 'active'], null)
    const blocks = state.getIn(
        ['authorization', 'accessRights', hocProps.module, 'custom', 'portfolios', activePortfolioType, 'blocks'],
        Map()
    )
    const sortedBlocks = blocks
        .toList()
        .sortBy((b) => b.get('order'))
        .map((b) => b.get('name'))
        .toArray()

    const workspaceBlocks = state.getIn(['ui', 'modules', hocProps.module, 'workspace', hocProps.id, 'blocks'], Map())
    const activeBlocks = workspaceBlocks
        .filter((block) => block.get('active') === true)
        .keySeq()
        .toList()

    const sortedActiveBlocks = sortedBlocks.filter((block) => activeBlocks.includes(block))

    return {
        blocks: sortedActiveBlocks,
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
